<template>
  <div class="flex flex-direction align-center">
    <el-form
      ref="exchangeForm"
      :model="exchangeData"
      :rules="exchangeDataRules"
      :label-position="UI.isMobile ? 'top' : 'left'"
      :label-width="UI.isMobile ? undefined : '120px'"
      style="width: 90%;"
    >
      <el-form-item label="交流到" prop="organization">
        <el-select
          filterable
          v-model="exchangeData.organization"
          placeholder="请选择"
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="(item, index) in organizationList"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <el-button
      class="login-button padding-xs margin-top"
      type="primary"
      size="mini"
      @click="submit()"
    >
      提交审核
    </el-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { baseUrl } from '@/utils/consts.js';
import { showErrorMsg, showSuccessMsg } from '@/utils/uiUtils.js';
import { getOrgs, movePlayerToOrg } from '@/servers/org.js';

export default {
  data() {
    return {
      organizationList: [],
      uploadUrl: baseUrl,
      exchangeDataRules: {
        organization: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  props: {
    exchangeData: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },

  created() {
    let that = this;
    getOrgs(function(res) {
      that.organizationList = [];
      res.forEach((item) => {
        that.organizationList.push({
          label: item.organization,
          value: item.id,
        });
      });
    });
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  methods: {
    ...mapMutations(['getUserState']),

    submit: function() {
      let that = this;
      this.$refs.exchangeForm.validate((valid) => {
        if (valid) {
          if (this.exchangeData.id) {
            console.log(this.exchangeData.organization);
            movePlayerToOrg(
              this.exchangeData.organization,
              this.exchangeData.id,
              function(res) {
                showSuccessMsg(res);
                that.getUserState();
                that.$emit('success');
              },
            );
          } else {
            showErrorMsg('请刷新重试.');
          }
        } else {
          showErrorMsg('请检查输入的参数.');
        }
      });
    },
  },
};
</script>
<style scoped>
.login-button {
  width: 200px;
}

.verify-bar-area {
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/info/exchangeEdit.vue